import './CpuHp.css';
import HP from "../../hp/HP";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";


function CpuHp() {

    const {cpuHp, battleBg} = useTypedSelector(state => state.game);

    const bgClass = 'cpuHP' + battleBg;

    return (
        <div className={'cpuHP ' + bgClass} >
            <HP key={'cpuhp1'} hp={cpuHp} side={'cpu'}  />
        </div>
    );
}

export default CpuHp;